import { AppLinkTree } from "@megarax/links";
import { useLocation, useSearchParams } from "react-router-dom-v5-compat";

import { resolveNavAccentColors } from "./navAccentUtils";

export const useNavAccentColor = (linkTree: AppLinkTree[]) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  return resolveNavAccentColors(linkTree, location.pathname, searchParams);
};
